// components/PrintContent.tsx
import React from "react";
import { COMPANY_NAME } from "src/shared/utils/brand";
import { OrderDetail, BusinessPrintData, OrganizationDetails } from "../hooks/types";
import CustomerInfo from "./CustomerInfo";
import ProductTable from "./ProductTable";
import PaymentSummary from "./PaymentSummary";
import BusinessHeader from "./BusinessHeader";
import { Order } from "src/shared/services/interfacev2";

interface PrintContentProps {
  orderData: Order;
  orderId: string | null;
  businessPrint: BusinessPrintData;
  organizationData: OrganizationDetails[];
}

const PrintContent: React.FC<PrintContentProps> = ({ orderData, orderId, businessPrint, organizationData }) => {
  return (
    <div
      className="print-content"
      style={{
        width: "100%",
        minWidth: "80mm",
        maxWidth: "80mm",
        margin: "0 auto",
        padding: "8px 10px 5px 10px",
        fontFamily: "Arial, sans-serif",
        fontSize: "11px", // Smaller font to fit more content
        lineHeight: "1.1",
        wordWrap: "break-word",
        overflowWrap: "break-word",
        backgroundColor: "white",
        color: "black",
        boxSizing: "border-box",
      }}
    >
      <BusinessHeader businessPrint={businessPrint} organizationData={organizationData} />

      <div
        style={{
          textAlign: "center",
          margin: "4px 0",
          borderBottom: "1px dashed #000",
          paddingBottom: "3px",
        }}
      >
        <h3 style={{ 
          margin: 0, 
          fontSize: "12px", 
          fontWeight: "bold",
        }}>INVOICE</h3>
      </div>

      <CustomerInfo orderData={orderData} orderId={orderId} />
      <ProductTable orderData={orderData} />
      <PaymentSummary orderData={orderData} />

      <div style={{ 
        textAlign: "center", 
        marginTop: "6px", 
        fontSize: "9px",
        borderTop: "1px dashed #000",
        paddingTop: "4px"
      }}>
        <p style={{ margin: "2px 0", fontStyle: "italic" }}>Thank you for your business!</p>
        <p style={{ margin: "2px 0" }}>Powered by {COMPANY_NAME}</p>
      </div>
    </div>
  );
};

export default PrintContent;